module.exports = __webpack_public_path__ + "static/media/jumping-fizz.6547b02f.jpg";